const Rating = (props) => {

    const rating = Math.round(props.rating);

    return (<img className="rating" src={"../img/"+rating+"-stars.png"} alt=""></img>);
}

 
export default Rating;